import React, { Component } from "react"
import { Grid, Col, Row , Form, Modal,FormControl,
  FormGroup,InputGroup,
  ControlLabel,} from "react-bootstrap";

import ReactTable from "react-table-6"
import Moment from "react-moment"
import  WAValidator from "multicoin-address-validator"
import Loader from "components/Loader/loader.jsx"
import Button from "components/CustomButton/CustomButton.jsx"
import Select from "react-select";
import "react-table-6/react-table.css"
import IconImage from "components/Icon/icon.jsx"
import { userService } from 'helpers/user.service.jsx';
const Config = require("config")

class NewPayout extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectData:[],
      currency:'USD',
      asset:'',
      type:'',
      cryptoAmount:'',
      fiatAmount:0.00,
      icon:'',
      showType:false,
      showCryptoPay:false,
      showFiatoPay:false,
      balance:0,
      balanceError:null,
      address:'',
      addressError:null,
      showSend:false,
      showModal: false,
      ref_idError:null, 
      ref_id:'',
      refCheck:true,
      isSubmitted:false,
      showWithdrawError:false,
      withdrawError:false,

    }
    this.handleChangeCryptoAmount = this.handleChangeCryptoAmount.bind(this);
    this.handleValidate = this.handleValidate.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handlecheckRefid = this.handlecheckRefid.bind(this)
    this.handleChangeFiatAmount = this.handleChangeFiatAmount.bind(this)
  }

  componentWillMount() {

    var selectData=JSON.parse(localStorage.getItem('assets'));
   
    selectData['data'].unshift({
      "name": "Select currency to send",
      "asset_id": "",
      "explorer_url": "",
      "icon_url": ""
  });
  this.setState({selectData:selectData})
  }



  prepayment(){
    this.setState({ showModal: true})
    }
    
sendPayment(){
  userService.getinfo().then((data)=>{
  var user = JSON.parse(data)
  var token = user.token
  var currency = this.state.currency
  var asset = this.state.asset
  var address = this.state.address
  var amount = this.state.cryptoAmount
  var fiatAmount = this.state.fiatAmount
  var ref_id = this.state.ref_id
  const requestOptions = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
      "access-token": token,
      mid: user.data.merchant_id,
    },
    
   body: JSON.stringify({currency,address,amount,fiatAmount,ref_id})
};
var endpoint=''
if (asset.toLocaleLowerCase()=='ape' || asset.toLocaleLowerCase()=='matic' || asset.toLocaleLowerCase()=='shib' || asset.toLocaleLowerCase()=='usdt' || asset.toLocaleLowerCase()=='usdc'){
 endpoint=Config.API+`/api/withdraw_funds/erc20/`+asset
}else{
 endpoint=Config.API+`/api/withdraw_funds/`+asset
}

return fetch(endpoint,requestOptions)
.then( this.handleResponse)
.then( data => {if (data.status=='success'){ window.location.href='/#/payout_history'
}else{
this.setState({showWithdrawError:true,withdrawError:data.message})

}})
})
}    

getFiatAmount(){
  userService.getinfo().then((data)=>{
  var user = JSON.parse(data)
  var token = user.token
  var amount=this.state.cryptoAmount

  var from=this.state.asset
  var to='USD'

      const requestOptions = {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "access-token": token,
          mid: user.data.merchant_id,
        },
        
       body: JSON.stringify({ to,from,amount})
    };
        
  
return fetch(Config.API+`/api/fiatamount`,requestOptions)
.then( this.handlePriceResponse)
   .then( fiat => this.setState({fiatAmount:fiat.data.total_amount})).catch(function(){
    this.setState({fiatAmount:0})

   })
  
 
  
})
  }



getCryptoAmount(){
  userService.getinfo().then((data)=>{
  var user = JSON.parse(data)
  var token = user.token
  var amount=this.state.fiatAmount

  var from=this.state.asset
  var to=this.state.type

      const requestOptions = {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "access-token": token,
          mid: user.data.merchant_id,
        },
        
       body: JSON.stringify({ to,from,amount})
    };
        
  
return fetch(Config.API+`/api/cryptoamount`,requestOptions)
.then( this.handlePriceResponse)
   .then( fiat => this.setState({cryptoAmount:fiat.data.total_amount})).catch(function(){
    this.setState({cryptoAmount:0})

   })
  
 
})
  
  }



  handlecheckRefid() {
    if (this.state.ref_id.length>0)
      {this.checkRefid()}else{this.handleValidate()}
    
 
}


checkRefid(){
  userService.getinfo().then((data)=>{
    var user = JSON.parse(data)
    var token = user.token
    var ref_id=this.state.ref_id

        const requestOptions = {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "access-token": token,
            "mid": user.data.merchant_id,
          },
          
         body: JSON.stringify({ref_id})
      };
          
    
  return fetch(Config.API+`/api/checkwithdrawref`,requestOptions)
  .then( this.handleRefResponse)
     .then( (ref) => {
      ref.status=='error' 
    ? this.setState({refCheck:false},()=>{this.handleValidate()})
  :this.setState({refCheck:true},()=>{this.handleValidate()})}
     )
})
    }
  






showSendBtn(){
  var {address,cryptoAmount,addressError,balanceError,ref_idError} = this.state;
  if(cryptoAmount>0 &&  address!='' && balanceError==null && addressError==null && ref_idError==null){
 
      this.setState({showSend:true})
    }else{  

      this.setState({showSend:false})}
}
getBalance(){
  userService.getinfo().then((data)=>{
  var user = JSON.parse(data)
  var token = user.token
  var coin=this.state.asset

      const requestOptions = {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "access-token": token,
          mid: user.data.merchant_id,
        },
        
       body: JSON.stringify({coin})
    };
        
  
return fetch(Config.API+`/api/balance`,requestOptions)
.then( this.handleResponse)
   .then( balance => this.setState({balance:balance.data.balance}))
  })
  }



  handleAssetChange = (data)=> {
 
    this.setState({ asset:data.value,icon:data.icon,cryptoAmount:'',fiatAmount:0,address:'',addressError:null,balanceError: null,ref_idError:null,ref_id:'',showCryptoPay:false,showFiatPay:false,type:''},function(){
if(this.state.asset!='')
{this.setState({showType:true},()=>{
  this.getBalance()
})}else{this.setState({cryptoAmount:'',fiatAmount:0,type:'',showCryptoPay:false,showFiatPay:false,showType:false})}

    })
    
      };



  handleTypeChange = (data)=> {
   
    this.setState({type:data.value,cryptoAmount:'',fiatAmount:0.00,address:'',addressError:null,balanceError: null,ref_idError:null,ref_id:''},function(){
   
      if(this.state.type=='Crypto')
      {this.setState({showCryptoPay:true,showFiatPay:false,currency:'USD'})}else if(this.state.type=='USD' || this.state.type=='CAD' || this.state.type=='EUR' || this.state.type=='GBP' )
      {this.setState({showFiatPay:true,showCryptoPay:false,currency:this.state.type},function(){ })}else{this.setState({showCryptoPay:false,showFiatPay:false,currency:'USD'})}
      



          })
    
      };


      handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value })
  
    }

handleResponse(response) {

  return response.text().then(text => {
      const data = text && JSON.parse(text);

      if (!response.ok) {
          
       // const error = (data && data.message);
        return 'error'
      }else{

      }
     

      return data;
  });
}


handleRefResponse(response) {

  return response.text().then(text => {
      const data = text && JSON.parse(text);



      return data;
  });
}

handlePaymentResponse(response) {

  return response.text().then(text => {
      const data = text && JSON.parse(text);

      if (!response.ok) {
          
       // const error = (data && data.message);
        return 'error'
      }else{

      }
     

      return data;
  });
}

handlePriceResponse(response) {

  return response.text().then(text => {
      var data = text && JSON.parse(text);

      if (!response.ok) {
          
       // const error = (data && data.message);
        return 'error'
      }else{
        if(data.status=='error'){
 
     return 'error'
            }
          

      }
     

      return data;
  });
}

handleValidateAddress() {
  this.validateaddress()
}


handleValidate() {

this.state.cryptoAmount==''
?this.setState({ balanceError: null },()=>{this.showSendBtn()})
  :this.state.cryptoAmount > this.state.balance
  ? this.setState({
    balanceError: (
        <small className="text-danger">The requested amount exceeds your balance</small>
      ),
    },()=>{this.showSendBtn()})
  : this.setState({ balanceError: null },()=>{this.showSendBtn()})

this.state.refCheck==false || this.state.ref_id==''
? this.setState({
  ref_idError: (
      <small className="text-danger">A unique Ref ID is required</small>
    ),
  },()=>{this.showSendBtn()})
: this.setState({ ref_idError: null },()=>{this.showSendBtn()})


var assetcheck=''
if(this.state.address!=''){
  assetcheck=this.state.asset
  if ( this.state.asset=='USDT' || this.state.asset=='USDT'){assetcheck='ETH'}
  if (this.state.asset=='USDT_TRON'){assetcheck='TRX'}


var valid = WAValidator.validate(this.state.address, (assetcheck).toLocaleLowerCase(), 'mainnet');
if(valid)
this.setState({addressError:null},()=>{this.showSendBtn()})
else
this.setState({addressError:(<small className="text-danger">Invalid address</small>)},()=>{this.showSendBtn()})
}else{this.setState({addressError:<small className="text-danger">Address is required</small>},()=>{this.showSendBtn()})}


}

  handleChangeCryptoAmount(e) {

    const { name, value } = e.target;
    this.setState({ [name]: value },()=>{
      if(isNaN(this.state.cryptoAmount)){this.setState({cryptoAmount:'',fiatAmount:0})}else{

        this.getFiatAmount()
      }
  
    })
 
}


handleChangeFiatAmount(e) {

  const { name, value } = e.target;
  this.setState({ [name]: value },()=>{
    if(isNaN(this.state.fiatAmount)){this.setState({cryptoAmount:'',fiatAmount:0})}else{

      this.getCryptoAmount()
    }

  })

}
  render() {
    const {selectData,asset,type,cryptoAmount,icon,showType,showCryptoPay,showFiatPay,fiatAmount,balance,balanceError,address,addressError,showSend,isSubmitted,ref_id,ref_idError,showWithdrawError,withdrawError} = this.state;
    var data=selectData.data

    const assetOptions=  data.map(e => {
      return (
       {value:e.asset_id, label:e.name,icon:e.icon_url}
      );
    })

 
    var typeOptions=[{value:'', label:'Select amount by'},{value:'Crypto', label:'Crypto'},{value:'CAD', label:'CAD'},{value:'USD', label:'USD'},{value:'EUR', label:'EUR'},{value:'GBP', label:'GBP'}]


    return (
      <div className="main-content buy">
  
                  <Grid fluid>
                      <Row>
                      <Col lg={12}>
              {" "}
              <h3 className="header">New Payout</h3>
            </Col>
                <Col lg={12}>
              <div className="card">
                <div className="content" style={{display:"flex"}}>
                      <Col lg={10} >   <Form horizontal >
                      <FormGroup controlId="formHorizontalRequiredText">
                  
                        <Col lg={12}>
                        <Select
              
              placeholder="Select currency to send"     
              name="asset"
              value={asset}
              options={assetOptions}
              onChange={this.handleAssetChange}
       
            />
                        </Col>
                      </FormGroup>
                    {showType
                      ?<FormGroup controlId="formHorizontalRequiredText">
                     
                        <Col lg={12}>
                        <Select
              
              placeholder="Select amount by"     
              name="type"
              value={type}
              options={typeOptions}
              onChange={this.handleTypeChange}
            />
                        </Col>
                      </FormGroup>
                      :''} 
                  {showCryptoPay     
                  ?<div className="buy">
                    <Col sm={12} md={12}>  <div style={{fontSize:"20px",marginTop:"20px",marginBottom:"20px"}} ><img src={icon} style={{height:"40px"}}/> Balance : {balance}  </div></Col>
                    
                    
                    <Col sm={12} md={5}>
     <FormGroup controlId="formHorizontalRequiredText" bsSize="large">  
     <div>Amount to Send</div>
    <InputGroup>
      <InputGroup.Addon><img src={icon} style={{height:"30px"}}/></InputGroup.Addon>
      <FormControl type="text" placeholder="0"
       name='cryptoAmount'
          value={cryptoAmount}
          onChange={this.handleChangeCryptoAmount}
          onBlur={this.handleValidate}
   />  
      <InputGroup.Addon>{asset}</InputGroup.Addon>
    </InputGroup>   <div>{balanceError}</div>
  </FormGroup>

  </Col>
  <Col sm={12} md={1}></Col>
                       
                       <Col sm={12} md={5}>
  <FormGroup controlId="formHorizontalRequiredText" bsSize="large">  
 <div >Value</div>
<InputGroup>
  <InputGroup.Addon><i class="fas fa-dollar-sign" style={{width:"30px"}}></i></InputGroup.Addon>
  <FormControl type="number" placeholder="0.00"
   name='fiatAmount'
   disabled='true'
      value={fiatAmount}
     
/>
  <InputGroup.Addon>USD</InputGroup.Addon>
</InputGroup> 
</FormGroup>
  
</Col>
<FormGroup controlId="formHorizontalRequiredText">
                        
                        <Col lg={12}> Ref ID
                          <FormControl
                            type="text"
                            name="ref_id"
                            value={ref_id}
                         onChange={this.handleChange}
                         onBlur={this.handlecheckRefid}
                          /> <div>{ref_idError}</div> 
                        </Col>
                      
                      </FormGroup>
<FormGroup controlId="formHorizontalRequiredText">
                        
                        <Col lg={12}> Destination Wallet Address
                          <FormControl
                            type="text"
                            name="address"
                            value={address}
                         onChange={this.handleChange}
                         onBlur={this.handleValidate}
                          /> <div>{addressError}</div> 
                        </Col>
                      
                      </FormGroup>

</div>
:''}

{showFiatPay     
                  ?<div className="buy">
                    <Col sm={12} md={12}>  <div style={{fontSize:"20px",marginTop:"20px",marginBottom:"20px"}} ><img src={icon} style={{height:"40px"}}/> Balance : {balance}  </div></Col>
                      <Col sm={12} md={5}>
  <FormGroup controlId="formHorizontalRequiredText" bsSize="large">  
 <div >Value</div>
<InputGroup>
  <InputGroup.Addon>
  {this.state.type=='CAD' || this.state.type=='USD'
  ?<i class="fas fa-dollar-sign" style={{width:"30px"}}></i>
  : this.state.type=='EUR'
  ?<i class="fas fa-euro-sign" style={{width:"30px"}}></i>
  :this.state.type=='GBP'
  ?<i class="fas fa-pound-sign" style={{width:"30px"}}></i>
  :<i class="fas fa-dollar-sign" style={{width:"30px"}}></i>}
   </InputGroup.Addon>
  <FormControl type="number" placeholder="0.00"
   name='fiatAmount'
   onChange={this.handleChangeFiatAmount}
      value={fiatAmount}
         
      onBlur={this.handleValidate}
/>
  <InputGroup.Addon>{this.state.type}</InputGroup.Addon>
</InputGroup> 
</FormGroup>
  
</Col>
                <Col sm={12} md={1}></Col>      
                    <Col sm={12} md={5}>
     <FormGroup controlId="formHorizontalRequiredText" bsSize="large">  
     <div>Amount to Send</div>
    <InputGroup>
      <InputGroup.Addon><img src={icon} style={{height:"30px"}}/></InputGroup.Addon>
      <FormControl type="text" placeholder="0"
       name='cryptoAmount'
       disabled='true'
          value={cryptoAmount}
      
   />  
      <InputGroup.Addon>{asset}</InputGroup.Addon>
    </InputGroup>   <div>{balanceError}</div>
  </FormGroup>

  </Col>

                       
                     
<FormGroup controlId="formHorizontalRequiredText">
                        
                        <Col lg={12}> Ref ID
                          <FormControl
                            type="text"
                            name="ref_id"
                            value={ref_id}
                         onChange={this.handleChange}
                         onBlur={this.handlecheckRefid}
                          /> <div>{ref_idError}</div> 
                        </Col>
                      
                      </FormGroup>
<FormGroup controlId="formHorizontalRequiredText">
                        
                        <Col lg={12}> Destination Wallet Address
                          <FormControl
                            type="text"
                            name="address"
                            value={address}
                         onChange={this.handleChange}
                         onBlur={this.handleValidate}
                          /> <div>{addressError}</div> 
                        </Col>
                      
                      </FormGroup>

</div>
:''}

<FormGroup controlId="formHorizontalRequiredText">
                        
                        <Col lg={12}> 
                  {showSend
                    ?<Button
                      fill
                      bsStyle="info"
                     simple
                    
                      onClick={ ()=>(this.prepayment())}
                    >
                      Send Payment
                    </Button>
                    :''}
                    </Col>
                      
                      </FormGroup>
                  
                  
                      </Form>
                      </Col>

                      </div>
              </div>
            </Col>
                    </Row>
                      </Grid>
                    

                      <Modal
  backdrop='static'
  keyboard={false}
                      show={this.state.showModal}
                      onHide={() => this.setState({ showModal: false})}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Verify Payment</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                      <Grid fluid>
                      <Row>
         
       
         <Col lg={12} >   
         <Col lg={4}>   
        Send
         </Col> <Col lg={8}>   
           {cryptoAmount} <img src={icon} style={{height:"20px"}}/> {asset}
         </Col>
         </Col>
         <Col lg={12} style={{marginTop:"20px"}}>  
         <Col lg={4}>   
      Wallet Address
         </Col> <Col lg={8}>   
          {address}
         </Col>
         </Col>
                      </Row></Grid>
                      </Modal.Body>
                      <Modal.Footer>

                   {showWithdrawError
                   ?  <div>
                    <div><small className="text-danger" style={{float:"left"}}>{withdrawError}</small></div> 
                    <Button
              
                   simple
                   onClick={()=>{window.location.href='/#/payout_history'}}
                   
                  >Cancel
                  </Button></div>
                   :    <span><Button
                          simple
                          onClick={() => this.setState({ showModal: false })}
                        >Cancel
                        </Button>
                        <Button
                         disabled={isSubmitted}
                         simple
                         onClick={()=>{this.setState({isSubmitted:true},()=>{this.sendPayment()})}}
                         
                        >Confirm Payment
                        </Button></span> }
                      </Modal.Footer>
                    </Modal>
                   
      </div>
    )
  }
}

export default NewPayout
